const selectItems = (state) => state.items;

export const selectItemList = (state) => selectItems(state).list;

export const selectHasItemsLoaded = (state) => selectItems(state).hasItems;
